(() => {
  const root = document.querySelector(".fh-maker");
  if (!root) return;

  root.addEventListener("click", e => {
    const panelToggleBtn = e.target.closest("[data-panel-toggle]");
    if (!panelToggleBtn) return;

    const bodyId = panelToggleBtn.dataset.panelToggle;
    const bodyEl = document.getElementById(bodyId);
    if (!bodyEl) return;

    const willOpen = bodyEl.hasAttribute("hidden");
    if (willOpen) {
      bodyEl.removeAttribute("hidden");
      panelToggleBtn.setAttribute("aria-expanded", "true");
      panelToggleBtn.querySelector("span").textContent = "Collapse";
    } else {
      bodyEl.setAttribute("hidden", "");
      panelToggleBtn.setAttribute("aria-expanded", "false");
      panelToggleBtn.querySelector("span").textContent = "Expand";
    }
  });

  const loggedIn = root.dataset.customerLoggedIn === "1";
  if (!loggedIn) return;

  const STORAGE_KEY = "fh_maker_dashboard_v2";
  const CART_BUILDER_KEY = "fh_cart_builder_v2";

  const metaEl = document.getElementById("fh-customer-metafields");
  const catalogEl = document.getElementById("fh-filament-catalog");
  const ordersEl = document.getElementById("fh-orders");

  const searchEl = document.getElementById("fh-search");
  const orderedSortEl = document.getElementById("fh-ordered-sort");
  const orderedMaterialFiltersEl = document.getElementById("fh-ordered-material-filters");
  const notTriedSortEl = document.getElementById("fh-not-tried-sort");

  const orderedListEl = document.getElementById("fh-ordered-list");
  const favListEl = document.getElementById("fh-favourites");
  const chipsEl = document.getElementById("fh-not-tried-chips");
  const notTriedListEl = document.getElementById("fh-not-tried-list");

  function safeJson(txt, fallback) {
    try {
      return JSON.parse(txt || "");
    } catch {
      return fallback;
    }
  }

  function escapeHtml(str) {
    return String(str ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function centsToMoney(cents) {
    const n = Number(cents || 0) / 100;
    try {
      return n.toLocaleString(undefined, { style: "currency", currency: "AUD" });
    } catch {
      return `$${n.toFixed(2)}`;
    }
  }

  function ymd(dateStrOrDate) {
    if (!dateStrOrDate) return "—";
    const d = dateStrOrDate instanceof Date ? dateStrOrDate : new Date(dateStrOrDate);
    if (Number.isNaN(d.getTime())) return "—";
    return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  }

  function daysBetween(dateA, dateB = new Date()) {
    const a = dateA instanceof Date ? dateA : new Date(dateA);
    const b = dateB instanceof Date ? dateB : new Date(dateB);
    if (Number.isNaN(a.getTime()) || Number.isNaN(b.getTime())) return null;
    const ms = Math.abs(b.setHours(0, 0, 0, 0) - a.setHours(0, 0, 0, 0));
    return Math.round(ms / 86400000);
  }

  function handleFromUrl(url) {
    if (!url) return "";
    const m = String(url).match(/\/products\/([^/?#]+)/i);
    return m ? m[1] : "";
  }

  function slugify(str) {
    return String(str || "")
      .toLowerCase()
      .trim()
      .replace(/['"]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function setText(id, value) {
    const el = document.getElementById(id);
    if (el) el.textContent = value;
  }

  function isValidHex(value) {
    return /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(String(value || "").trim());
  }

  function getProductHexes(product) {
    return [
      String(product?.hex_colour || "").trim(),
      String(product?.hex_colour_2 || "").trim(),
      String(product?.hex_colour_3 || "").trim()
    ].filter(isValidHex);
  }

  function renderColourBubble(product) {
    const hexes = getProductHexes(product);
    if (!hexes.length) return "";

    let background = hexes[0];
    if (hexes.length === 2) {
      background = `linear-gradient(135deg, ${hexes[0]} 0 50%, ${hexes[1]} 50% 100%)`;
    } else if (hexes.length >= 3) {
      background = `linear-gradient(135deg, ${hexes[0]} 0 33.33%, ${hexes[1]} 33.33% 66.66%, ${hexes[2]} 66.66% 100%)`;
    }

    return `
      <span
        class="fh-colour-bubble"
        aria-hidden="true"
        style="background:${background};"
        title="${escapeHtml(hexes.join(" / "))}"
      ></span>
    `;
  }

  function materialFromTitle(title) {
    const t = String(title || "").toUpperCase();
    if (t.includes("PCTG")) return "PCTG";
    if (t.includes("PETG")) return "PETG";
    if (t.includes("NYLON") || t.includes(" PA ")) return "Nylon";
    if (t.includes("TPU")) return "TPU";
    if (t.includes("ASA")) return "ASA";
    if (t.includes("ABS")) return "ABS";
    if (t.includes("PLA")) return "PLA";
    if (t.includes("PC")) return "PC";
    if (t.includes("CF") || t.includes("CARBON FIBER")) return "CF";
    if (t.includes("PVA")) return "PVA";
    return "Other";
  }

  function finishFromProduct(product) {
    const subcat = String(product?.subcategory || "").trim();
    if (subcat && subcat !== "All") return subcat;

    const title = String(product?.title || "").toLowerCase();
    if (title.includes("matte")) return "Matte";
    if (title.includes("silk")) return "Silk";
    if (title.includes("galaxy")) return "Galaxy";
    if (title.includes("glitter")) return "Glitter";
    if (title.includes("marble")) return "Marble";
    if (title.includes("metal")) return "Metal";
    if (title.includes("translucent")) return "Translucent";
    if (title.includes("crystal")) return "Crystal";
    return "Standard";
  }

  function materialFromProduct(product) {
    if (product?.material) return String(product.material).trim();

    const tags = Array.isArray(product?.tags) ? product.tags.map(t => String(t).toLowerCase()) : [];
    const matTag = tags.find(t => t.startsWith("mat_"));
    if (matTag) {
      const raw = matTag.slice(4).toUpperCase();
      if (raw === "NYLON" || raw === "PA") return "Nylon";
      return raw;
    }

    return materialFromTitle(product?.title || "");
  }

  function isFilamentLineItem(li) {
    const title = String(li?.title || li?.product_title || "").toLowerCase();
    const productTitle = String(li?.product_title || "").toLowerCase();
    const variantTitle = String(li?.variant_title || "").toLowerCase();
    const haystack = `${title} ${productTitle} ${variantTitle}`;
    return (
      haystack.includes("pla") ||
      haystack.includes("petg") ||
      haystack.includes("abs") ||
      haystack.includes("asa") ||
      haystack.includes("tpu") ||
      haystack.includes("pctg") ||
      haystack.includes("nylon") ||
      haystack.includes("pva") ||
      haystack.includes("carbon fiber") ||
      haystack.includes("cf") ||
      haystack.includes(" pc ")
    );
  }

  function loadLocalState() {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
      return {
        favourites: Array.isArray(parsed.favourites) ? parsed.favourites : [],
        notes: parsed.notes || {},
        reminders: parsed.reminders || {},
        hiddenMaterials: Array.isArray(parsed.hiddenMaterials) ? parsed.hiddenMaterials : [],
        orderedMaterialFilter: parsed.orderedMaterialFilter || "All",
        orderedSort: parsed.orderedSort || "recent",
        notTriedSort: parsed.notTriedSort || "az"
      };
    } catch {
      return {
        favourites: [],
        notes: {},
        reminders: {},
        hiddenMaterials: [],
        orderedMaterialFilter: "All",
        orderedSort: "recent",
        notTriedSort: "az"
      };
    }
  }

  function saveLocalState(state) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch {}
  }

  function mergeMeta(serverMeta, localMeta) {
    return {
      favourites: Array.isArray(localMeta?.favourites) && localMeta.favourites.length
        ? localMeta.favourites
        : (Array.isArray(serverMeta?.favourites) ? serverMeta.favourites : []),
      notes: typeof localMeta?.notes === "object" && localMeta.notes
        ? localMeta.notes
        : (serverMeta?.notes || {}),
      reminders: typeof localMeta?.reminders === "object" && localMeta.reminders
        ? localMeta.reminders
        : (serverMeta?.reminders || {}),
      hiddenMaterials: Array.isArray(localMeta?.hiddenMaterials)
        ? localMeta.hiddenMaterials
        : [],
      orderedMaterialFilter: localMeta?.orderedMaterialFilter || "All",
      orderedSort: localMeta?.orderedSort || "recent",
      notTriedSort: localMeta?.notTriedSort || "az"
    };
  }

  function persistMeta() {
    saveLocalState({
      favourites: Array.isArray(meta.favourites) ? meta.favourites : [],
      notes: meta.notes || {},
      reminders: meta.reminders || {},
      hiddenMaterials: Array.isArray(meta.hiddenMaterials) ? meta.hiddenMaterials : [],
      orderedMaterialFilter: state.orderedMaterialFilter,
      orderedSort: state.orderedSort,
      notTriedSort: state.notTriedSort
    });
  }

  function loadCartBuilder() {
    try {
      const parsed = JSON.parse(localStorage.getItem(CART_BUILDER_KEY) || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  function saveCartBuilder(items) {
    try {
      localStorage.setItem(CART_BUILDER_KEY, JSON.stringify(items));
    } catch {}
  }

  const orders = safeJson(ordersEl?.textContent, []);
  const catalogRaw = safeJson(catalogEl?.textContent, []);
  const serverMeta = safeJson(metaEl?.textContent, { favourites: [], notes: {}, reminders: {} });
  const meta = mergeMeta(serverMeta, loadLocalState());

  const state = {
    orderedMaterialFilter: meta.orderedMaterialFilter || "All",
    orderedSort: meta.orderedSort || "recent",
    notTriedSort: meta.notTriedSort || "az",
    activeNotTriedMaterial: "PLA",
    activeNotTriedSubcategory: "All"
  };

  const catalogByHandle = new Map();
  const catalogByProductId = new Map();
  const catalogByVariantId = new Map();

  for (const product of catalogRaw) {
    if (!product?.handle) continue;
    if (!catalogByHandle.has(product.handle)) {
      catalogByHandle.set(product.handle, product);
    }
    if (product?.id && !catalogByProductId.has(String(product.id))) {
      catalogByProductId.set(String(product.id), product);
    }
    if (product?.variant_id && !catalogByVariantId.has(String(product.variant_id))) {
      catalogByVariantId.set(String(product.variant_id), product);
    }
  }

  const catalog = Array.from(catalogByHandle.values());
  let cartBuilder = loadCartBuilder();
  let cartActionInProgress = false;

  function getFavSet() {
    return new Set(Array.isArray(meta.favourites) ? meta.favourites : []);
  }

  function productUrlFor(item) {
    if (item.url) return item.url;
    if (item.handle) return `/products/${encodeURIComponent(item.handle)}`;
    return "#";
  }

  function imageFor(item) {
    if (item?.image) return item.image;
    return "";
  }

  function enrichWithCatalog(base) {
    const cat =
      catalogByVariantId.get(String(base.variant_id || "")) ||
      catalogByProductId.get(String(base.product_id || "")) ||
      catalogByHandle.get(base.handle);

    if (!cat) {
      return {
        ...base,
        finish: finishFromProduct(base)
      };
    }

    return {
      ...base,
      title: cat.title || base.title,
      url: cat.url || base.url,
      image: cat.image || base.image,
      available: typeof cat.available === "boolean" ? cat.available : base.available,
      variant_available: typeof cat.variant_available === "boolean" ? cat.variant_available : base.variant_available,
      inventory_quantity: typeof cat.inventory_quantity !== "undefined" ? cat.inventory_quantity : base.inventory_quantity,
      inventory_policy: typeof cat.inventory_policy !== "undefined" ? cat.inventory_policy : base.inventory_policy,
      inventory_management: typeof cat.inventory_management !== "undefined" ? cat.inventory_management : base.inventory_management,
      price: typeof cat.price !== "undefined" ? cat.price : base.price,
      material: materialFromProduct(cat) || base.material,
      subcategory: cat.subcategory || base.subcategory || "All",
      finish: finishFromProduct(cat),
      variant_id: cat.variant_id || base.variant_id || null,
      variant_title: cat.variant_title || base.variant_title || "",
      hex_colour: cat.hex_colour || base.hex_colour || "",
      hex_colour_2: cat.hex_colour_2 || base.hex_colour_2 || "",
      hex_colour_3: cat.hex_colour_3 || base.hex_colour_3 || ""
    };
  }

  function getInventoryStatus(product) {
    const qty = Number(product?.inventory_quantity ?? 0);
    const policy = String(product?.inventory_policy || "").toLowerCase();
    const variantAvailable = !!product?.variant_available;
    const inventoryManaged = product?.inventory_management !== null && product?.inventory_management !== "";

    if (inventoryManaged && qty > 0) {
      return { label: "In stock", state: "in-stock", priority: 0 };
    }

    if (variantAvailable && qty <= 0 && policy === "continue") {
      return { label: "Pre-order", state: "preorder", priority: 1 };
    }

    if (!inventoryManaged && variantAvailable) {
      return { label: "Available", state: "available", priority: 2 };
    }

    return { label: "Out of stock", state: "out-of-stock", priority: 3 };
  }

  const purchasedMap = new Map();
  const materialTotals = new Map();
  const colourTotals = new Map();
  const finishTotals = new Map();

  let totalRolls = 0;
  let lastReorder = null;
  let orderCountWithFilament = 0;

  for (const order of orders) {
    let rollsThisOrder = 0;

    for (const li of (order.line_items || [])) {
      if (!isFilamentLineItem(li)) continue;

      const qty = Number(li.quantity || 0) || 0;
      const rawTitle = li.product_title || li.title || "Untitled product";
      const orderDate = new Date(order.created_at);

      const handle =
        handleFromUrl(li.url) ||
        (catalogByVariantId.get(String(li.variant_id || ""))?.handle) ||
        (catalogByProductId.get(String(li.product_id || ""))?.handle) ||
        slugify(rawTitle);

      const catalogMatch =
        catalogByVariantId.get(String(li.variant_id || "")) ||
        catalogByProductId.get(String(li.product_id || "")) ||
        catalogByHandle.get(handle);

      const material = catalogMatch ? materialFromProduct(catalogMatch) : materialFromTitle(rawTitle);
      const finish = catalogMatch ? finishFromProduct(catalogMatch) : "Standard";
      const colourLabel = (() => {
        const title = String(catalogMatch?.title || rawTitle || "");
        const materialPrefix = String(material || "").toLowerCase();
        return title.toLowerCase().startsWith(materialPrefix.toLowerCase())
          ? title.slice(material.length).trim().replace(/^[-–—:|]+/, "").trim() || title
          : title;
      })();

      totalRolls += qty;
      rollsThisOrder += qty;

      materialTotals.set(material, (materialTotals.get(material) || 0) + qty);
      finishTotals.set(finish, (finishTotals.get(finish) || 0) + qty);
      colourTotals.set(colourLabel, (colourTotals.get(colourLabel) || 0) + qty);

      const prev = purchasedMap.get(handle) || {
        handle,
        product_id: li.product_id || null,
        variant_id: li.variant_id || null,
        title: rawTitle,
        qty: 0,
        lastDate: null,
        material,
        finish,
        subcategory: catalogMatch?.subcategory || "All",
        url: li.url || "",
        image: "",
        available: undefined,
        variant_available: undefined,
        inventory_quantity: 0,
        inventory_policy: "",
        inventory_management: null,
        price: undefined,
        variant_title: li.variant_title || "",
        hex_colour: "",
        hex_colour_2: "",
        hex_colour_3: ""
      };

      prev.qty += qty;
      prev.material = material;
      prev.finish = finish;
      prev.product_id = prev.product_id || li.product_id || null;
      prev.variant_id = prev.variant_id || li.variant_id || null;
      if (!prev.lastDate || orderDate > prev.lastDate) prev.lastDate = orderDate;
      if (!lastReorder || orderDate > lastReorder) lastReorder = orderDate;
      if ((prev.title || "").length < rawTitle.length) prev.title = rawTitle;
      if (!prev.url && li.url) prev.url = li.url;
      if (!prev.variant_title && li.variant_title) prev.variant_title = li.variant_title;

      purchasedMap.set(handle, enrichWithCatalog(prev));
    }

    if (rollsThisOrder > 0) {
      orderCountWithFilament += 1;
    }
  }

  const favMaterial = (() => {
    let bestName = "—";
    let bestQty = -1;
    for (const [mat, qty] of materialTotals.entries()) {
      if (qty > bestQty) {
        bestName = mat;
        bestQty = qty;
      }
    }
    return bestName;
  })();

  const mostReorderedColour = (() => {
    let bestName = "—";
    let bestQty = -1;
    for (const [name, qty] of colourTotals.entries()) {
      if (qty > bestQty) {
        bestName = name;
        bestQty = qty;
      }
    }
    return bestName;
  })();

  const mostReorderedFinish = (() => {
    let bestName = "—";
    let bestQty = -1;
    for (const [name, qty] of finishTotals.entries()) {
      if (qty > bestQty) {
        bestName = name;
        bestQty = qty;
      }
    }
    return bestName;
  })();

  const avgRolls = orderCountWithFilament ? (totalRolls / orderCountWithFilament) : 0;
  const daysSinceLastOrder = lastReorder ? daysBetween(lastReorder) : null;
  const averageDaysBetweenOrders = (() => {
    const filamentOrderDates = orders
      .filter(order => (order.line_items || []).some(isFilamentLineItem))
      .map(order => new Date(order.created_at))
      .filter(d => !Number.isNaN(d.getTime()))
      .sort((a, b) => a - b);

    if (filamentOrderDates.length < 2) return null;

    let totalDays = 0;
    for (let i = 1; i < filamentOrderDates.length; i += 1) {
      totalDays += daysBetween(filamentOrderDates[i - 1], filamentOrderDates[i]);
    }
    return Math.round(totalDays / (filamentOrderDates.length - 1));
  })();

  const restockStatus = (() => {
    if (!daysSinceLastOrder || !averageDaysBetweenOrders) return "No pattern yet";
    if (daysSinceLastOrder >= averageDaysBetweenOrders + 14) return "Likely due soon";
    if (daysSinceLastOrder >= averageDaysBetweenOrders) return "Getting close";
    return "Recently restocked";
  })();

  function renderHero() {
    const firstName = String(root.dataset.customerFirstName || "").trim();
    const newToTryCount = catalog.filter(product => !purchasedMap.has(product.handle)).length;

    setText("fh-total-rolls", String(totalRolls || 0));
    setText("fh-fav-material", favMaterial);
    setText("fh-avg-order", avgRolls.toFixed(1));
    setText("fh-top-colour", mostReorderedColour);
    setText("fh-top-finish", mostReorderedFinish);
    setText("fh-new-count", String(newToTryCount));
    setText("fh-hero-last-order", lastReorder ? ymd(lastReorder) : "—");
    setText("fh-hero-days-since", typeof daysSinceLastOrder === "number" ? `${daysSinceLastOrder} days` : "—");
    setText("fh-hero-restock", restockStatus);

    const heroNoteEl = document.getElementById("fh-hero-note");
    if (heroNoteEl) {
      const bits = [];
      if (firstName) bits.push(`Welcome back, ${firstName}.`);
      if (favMaterial && favMaterial !== "—") bits.push(`Your most-loved material is ${favMaterial}.`);
      if (restockStatus !== "No pattern yet") bits.push(`Restock status: ${restockStatus}.`);
      heroNoteEl.textContent = bits.join(" ") || "Welcome back to your FilamentHub maker insights.";
    }
  }

  function toggleFavourite(handle) {
    const favs = getFavSet();
    if (favs.has(handle)) favs.delete(handle);
    else favs.add(handle);

    meta.favourites = Array.from(favs);
    persistMeta();
    renderFavourites();
    renderOrdered();
  }

  function normalizeCartBuilderItem(product) {
    return {
      variant_id: product.variant_id || null,
      handle: product.handle || "",
      title: product.title || "Untitled",
      url: product.url || "",
      image: product.image || "",
      price: typeof product.price !== "undefined" ? product.price : 0,
      qty: 1,
      material: product.material || "",
      finish: product.finish || finishFromProduct(product),
      variant_title: product.variant_title || "",
      hex_colour: product.hex_colour || "",
      hex_colour_2: product.hex_colour_2 || "",
      hex_colour_3: product.hex_colour_3 || ""
    };
  }

  function addToCartBuilder(product) {
    if (!product?.variant_id) return;

    const variantId = String(product.variant_id);
    const existing = cartBuilder.find(item => String(item.variant_id) === variantId);

    if (existing) {
      existing.qty += 1;
    } else {
      cartBuilder.push(normalizeCartBuilderItem(product));
    }

    saveCartBuilder(cartBuilder);
    renderCartBuilder();
  }

  function removeFromCartBuilder(variantId) {
    cartBuilder = cartBuilder.filter(item => String(item.variant_id) !== String(variantId));
    saveCartBuilder(cartBuilder);
    renderCartBuilder();
  }

  function updateCartBuilderQty(variantId, qty) {
    const item = cartBuilder.find(x => String(x.variant_id) === String(variantId));
    if (!item) return;
    item.qty = Math.max(1, Number(qty || 1));
    saveCartBuilder(cartBuilder);
    renderCartBuilder();
  }

  function cartBuilderCount() {
    return cartBuilder.reduce((sum, item) => sum + Number(item.qty || 0), 0);
  }

  function cartBuilderSubtotal() {
    return cartBuilder.reduce((sum, item) => sum + (Number(item.price || 0) * Number(item.qty || 0)), 0);
  }

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  function chunkArray(arr, size) {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  }

  function getCartActionButtons() {
    return {
      replaceBtn: document.getElementById("fh-replace-cart-checkout"),
      addBtn: document.getElementById("fh-add-tray-to-cart"),
      clearBtn: document.getElementById("fh-clear-cart-builder"),
      viewCartBtn: document.getElementById("fh-view-cart")
    };
  }

  function setCartActionState(isLoading, label = "Working...") {
    cartActionInProgress = isLoading;

    const { replaceBtn, addBtn, clearBtn, viewCartBtn } = getCartActionButtons();

    [replaceBtn, addBtn, clearBtn].forEach(btn => {
      if (!btn) return;
      if (!btn.dataset.originalText) btn.dataset.originalText = btn.textContent;
      btn.disabled = isLoading;
      btn.textContent = isLoading ? label : btn.dataset.originalText;
    });

    if (viewCartBtn) {
      if (!viewCartBtn.dataset.originalText) viewCartBtn.dataset.originalText = viewCartBtn.textContent;
      viewCartBtn.setAttribute("aria-disabled", isLoading ? "true" : "false");
      viewCartBtn.classList.toggle("is-disabled", isLoading);
      if (isLoading) {
        viewCartBtn.dataset.href = viewCartBtn.getAttribute("href") || "/cart";
        viewCartBtn.removeAttribute("href");
      } else if (!viewCartBtn.getAttribute("href")) {
        viewCartBtn.setAttribute("href", viewCartBtn.dataset.href || "/cart");
      }
    }
  }

async function getCurrentCart() {
    const res = await fetch("/cart.js", {
      method: "GET",
      headers: { Accept: "application/json" }
    });

    if (!res.ok) {
      throw new Error("Failed to read current cart");
    }

    return res.json();
  }

  function getCartQtyMap(cart) {
    const map = new Map();

    for (const item of (cart?.items || [])) {
      const variantId = String(item.id);
      map.set(variantId, Number(item.quantity || 0));
    }

    return map;
  }

  function parseShopifyError(rawText) {
    try {
      return JSON.parse(rawText || "{}");
    } catch {
      return { message: rawText || "Unknown cart error" };
    }
  }

  function isMaxQtyError(parsedError) {
    const msg = String(parsedError?.message || parsedError?.description || "").toLowerCase();
    return msg.includes("maximum quantity") || msg.includes("already in your cart");
  }

  async function postCartItemsInBatches(items, batchSize = 10) {
    const cart = await getCurrentCart();
    const currentQtyMap = getCartQtyMap(cart);

    const normalizedItems = items
      .map(item => {
        const variantId = String(item.id);
        const requestedQty = Number(item.quantity || 0);
        const alreadyInCart = Number(currentQtyMap.get(variantId) || 0);

        return {
          id: Number(item.id),
          quantity: requestedQty,
          alreadyInCart
        };
      })
      .filter(item => item.quantity > 0);

    const chunks = chunkArray(normalizedItems, batchSize);
    const skipped = [];

    for (let i = 0; i < chunks.length; i += 1) {
      const chunk = chunks[i];

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            items: chunk.map(item => ({
              id: item.id,
              quantity: item.quantity
            }))
          })
        });

        if (!res.ok) {
          const rawText = await res.text();
          const parsed = parseShopifyError(rawText);

          if (!isMaxQtyError(parsed)) {
            throw new Error(`Batch ${i + 1}/${chunks.length} failed: ${rawText || res.statusText}`);
          }

          // Fallback: try each item individually so one bad item doesn't block the rest
          for (const item of chunk) {
            try {
              const singleRes = await fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
                },
                body: JSON.stringify({
                  items: [{ id: item.id, quantity: item.quantity }]
                })
              });

              if (!singleRes.ok) {
                const singleText = await singleRes.text();
                const singleParsed = parseShopifyError(singleText);

                if (isMaxQtyError(singleParsed)) {
                  skipped.push({
                    id: item.id,
                    reason: singleParsed.description || singleParsed.message || "Maximum quantity reached"
                  });
                  continue;
                }

                throw new Error(singleText || singleRes.statusText);
              }
            } catch (singleErr) {
              throw new Error(`Item ${item.id} failed: ${singleErr.message}`);
            }

            await sleep(100);
          }
        }

      } catch (err) {
        throw err;
      }

      if (i < chunks.length - 1) {
        await sleep(140);
      }
    }

    return { skipped };
  }

  async function addTrayToExistingCart({ redirectTo = null } = {}) {
    const addItems = cartBuilder
      .filter(item => item && item.variant_id)
      .map(item => ({
        id: Number(item.variant_id),
        quantity: Number(item.qty || 1),
        title: item.title || "Item"
      }));

    if (!addItems.length || cartActionInProgress) return;

    try {
      setCartActionState(true, "Adding...");

      const result = await postCartItemsInBatches(addItems, 10);

      if (result?.skipped?.length) {
        console.warn("Some items were skipped:", result.skipped);
      }

      if (redirectTo) {
        window.location.href = redirectTo;
      } else if (result?.skipped?.length) {
        alert("Some items were added, but one or more products were already at their maximum cart quantity.");
      }
    } catch (err) {
      console.error("addTrayToExistingCart failed:", err);
      alert(`Sorry, there was a problem adding the tray to your cart.\n\n${err.message}`);
    } finally {
      setCartActionState(false);
      renderCartBuilder();
    }
  }

  async function replaceShopifyCartWithTray({ redirectTo = null } = {}) {
    const addItems = cartBuilder
      .filter(item => item && item.variant_id)
      .map(item => ({
        id: Number(item.variant_id),
        quantity: Number(item.qty || 1),
        title: item.title || "Item"
      }));

    if (!addItems.length || cartActionInProgress) return;

    const confirmed = window.confirm(
      "This will clear your current Shopify cart and replace it with the items in your quick reorder tray. Continue?"
    );
    if (!confirmed) return;

    try {
      setCartActionState(true, "Replacing...");

      const clearRes = await fetch("/cart/clear.js", {
        method: "POST",
        headers: { Accept: "application/json" }
      });

      if (!clearRes.ok) {
        const errText = await clearRes.text();
        throw new Error(`Failed to clear cart: ${errText || clearRes.statusText}`);
      }

      await sleep(180);

      const result = await postCartItemsInBatches(addItems, 10);

      if (result?.skipped?.length) {
        console.warn("Some items were skipped:", result.skipped);
      }

      if (redirectTo) {
        window.location.href = redirectTo;
      }
    } catch (err) {
      console.error("replaceShopifyCartWithTray failed:", err);
      alert(`Sorry, there was a problem replacing your cart.\n\n${err.message}`);
    } finally {
      setCartActionState(false);
      renderCartBuilder();
    }
  }

  function renderBadge(text, modifier = "") {
    return `<span class="fh-badge ${modifier ? `fh-badge--${modifier}` : ""}">${escapeHtml(text)}</span>`;
  }

  function renderThumb(item) {
    const img = imageFor(item);
    if (!img) {
      return `<div class="fh-thumb fh-thumb--placeholder" aria-hidden="true">FH</div>`;
    }
    return `<img class="fh-thumb" src="${escapeHtml(img)}" alt="${escapeHtml(item.title || "")}" loading="lazy">`;
  }

  function rowSearchHaystack(item) {
    return [
      item.title,
      item.material,
      item.finish,
      item.variant_title,
      item.handle
    ].join(" ").toLowerCase();
  }

  function buildOrderedMaterialFilters() {
    if (!orderedMaterialFiltersEl) return;

    const mats = Array.from(
      new Set(
        Array.from(purchasedMap.values())
          .map(item => item.material)
          .filter(Boolean)
      )
    ).sort((a, b) => a.localeCompare(b));

    const filters = ["All", "Favourites", ...mats];

    orderedMaterialFiltersEl.innerHTML = filters.map(mat => `
      <button
        type="button"
        class="fh-chip fh-chip--filter"
        data-ordered-material-filter="${encodeURIComponent(mat)}"
        aria-pressed="${state.orderedMaterialFilter === mat ? "true" : "false"}"
      >
        ${escapeHtml(mat)}
      </button>
    `).join("");
  }

  function makeRow(item, { favouriteMode = false, context = "ordered" } = {}) {
    const isFav = getFavSet().has(item.handle);
    const stock = getInventoryStatus(item);
    const boughtText = item.qty ? `Bought: ${item.qty}` : "New to you";
    const lastText = item.lastDate ? `Last: ${ymd(item.lastDate)}` : "Not ordered yet";
    const priceText = typeof item.price !== "undefined" ? centsToMoney(item.price) : "";
    const finishText = item.finish && item.finish !== "All" ? item.finish : "";
    const ctaViewLabel = "View product";
    const ctaTrayLabel = "Add to tray";

    return `
      <div class="fh-row ${context === "not-tried" ? "fh-row--product" : ""}">
        <div class="fh-row__left">
          <div class="fh-row__top">
            ${renderThumb(item)}

            <div class="fh-row__content">
              <div class="fh-row__title">
                <button type="button" class="fh-star" data-fav-toggle="${escapeHtml(item.handle)}" aria-pressed="${isFav ? "true" : "false"}">${isFav ? "★" : "☆"}</button>
                ${renderColourBubble(item)}
                <span>${escapeHtml(item.title || item.handle || "Untitled")}</span>
              </div>

              <div class="fh-row__badges">
                ${item.material ? renderBadge(item.material, "material") : ""}
                ${finishText ? renderBadge(finishText, "finish") : ""}
                ${renderBadge(stock.label, stock.state)}
                ${favouriteMode ? renderBadge("Pinned", "pinned") : ""}
              </div>

              <div class="fh-row__meta">
                ${context === "not-tried"
                  ? `You haven’t tried this one yet.${priceText ? ` • ${priceText}` : ""}`
                  : `${boughtText} • ${lastText}${priceText ? ` • ${priceText}` : ""}`
                }
              </div>
            </div>
          </div>
        </div>

        <div class="fh-row__actions">
          <a class="fh-btn fh-btn--ghost" href="${escapeHtml(productUrlFor(item))}">${ctaViewLabel}</a>
          ${item.variant_id && stock.state !== "out-of-stock"
            ? `<button type="button" class="fh-btn" data-add-tray="${escapeHtml(String(item.variant_id))}" data-handle="${escapeHtml(item.handle || "")}">${ctaTrayLabel}</button>`
            : ""}
        </div>
      </div>
    `;
  }

  function renderOrdered() {
    if (!orderedListEl) return;

    const q = String(searchEl?.value || "").trim().toLowerCase();
    let rows = Array.from(purchasedMap.values());

    if (state.orderedMaterialFilter === "Favourites") {
      const favSet = getFavSet();
      rows = rows.filter(item => favSet.has(item.handle));
    } else if (state.orderedMaterialFilter !== "All") {
      rows = rows.filter(item => item.material === state.orderedMaterialFilter);
    }

    rows = rows.filter(item => !q || rowSearchHaystack(item).includes(q));

    rows.sort((a, b) => {
      if (state.orderedSort === "qty") return (Number(b.qty || 0) - Number(a.qty || 0));
      if (state.orderedSort === "az") return String(a.title || "").localeCompare(String(b.title || ""));
      return new Date(b.lastDate || 0) - new Date(a.lastDate || 0);
    });

    if (!rows.length) {
      orderedListEl.innerHTML = `
        <div class="fh-empty">
          <div class="fh-empty__title">No matching filament found</div>
          <div class="fh-empty__text">Try a different search term, switch your material filter, or clear favourites-only mode.</div>
        </div>
      `;
      return;
    }

    orderedListEl.innerHTML = rows.map(item => makeRow(item, { context: "ordered" })).join("");
  }

  function renderFavourites() {
    if (!favListEl) return;

    const favs = Array.isArray(meta.favourites) ? meta.favourites : [];

    if (!favs.length) {
      favListEl.innerHTML = `
        <div class="fh-empty">
          <div class="fh-empty__title">No favourites yet</div>
          <div class="fh-empty__text">Star your go-to colours and materials from your order history to pin them here for faster reordering.</div>
        </div>
      `;
      return;
    }

    const rows = favs
      .map(handle => {
        const purchased = purchasedMap.get(handle);
        if (purchased) return purchased;

        const cat = catalogByHandle.get(handle);
        if (cat) {
          return {
            handle,
            title: cat.title,
            qty: 0,
            lastDate: null,
            material: materialFromProduct(cat),
            finish: finishFromProduct(cat),
            subcategory: cat.subcategory || "All",
            url: cat.url || "",
            image: cat.image || "",
            available: cat.available,
            variant_available: cat.variant_available,
            inventory_quantity: cat.inventory_quantity,
            inventory_policy: cat.inventory_policy,
            inventory_management: cat.inventory_management,
            price: cat.price,
            variant_id: cat.variant_id || null,
            variant_title: cat.variant_title || "",
            hex_colour: cat.hex_colour || "",
            hex_colour_2: cat.hex_colour_2 || "",
            hex_colour_3: cat.hex_colour_3 || ""
          };
        }

        return {
          handle,
          title: handle,
          qty: 0,
          lastDate: null,
          material: "—",
          finish: "",
          subcategory: "All",
          url: "",
          image: "",
          available: undefined,
          variant_available: undefined,
          inventory_quantity: 0,
          inventory_policy: "",
          inventory_management: null,
          price: undefined,
          variant_id: null,
          variant_title: "",
          hex_colour: "",
          hex_colour_2: "",
          hex_colour_3: ""
        };
      })
      .sort((a, b) => String(a.title || "").localeCompare(String(b.title || "")));

    favListEl.innerHTML = rows.map(item => makeRow(item, { favouriteMode: true, context: "favourites" })).join("");
  }

  function renderNotYetTriedProducts() {
    const subcatsEl = document.getElementById("fh-not-tried-subcats");
    const managerToggleEl = document.getElementById("fh-toggle-material-manager");
    const managerEl = document.getElementById("fh-material-manager");
    const visibilityEl = document.getElementById("fh-material-visibility");
    if (!chipsEl || !notTriedListEl || !subcatsEl || !visibilityEl) return;

    const hiddenMaterials = new Set(Array.isArray(meta.hiddenMaterials) ? meta.hiddenMaterials : []);
    const boughtHandles = new Set(Array.from(purchasedMap.keys()));

    const materialOrder = ["PLA", "PETG", "ABS", "ASA", "TPU", "PVA", "PC", "Nylon", "CF"];
    const subcatOrder = {
      PLA: [
        "All", "Pro", "Matte", "Silk", "Chameleon", "Crystal", "Crystal Rainbow",
        "Dual Silk", "Tri Silk", "Dual Matte", "Galaxy", "Luminous", "Glitter",
        "Metal", "Wood", "Marble", "Saturn", "Starlight", "Translucent"
      ],
      TPU: ["All", "95A", "95A Silk", "CF", "FPLA", "ShoeFlex"]
    };

    function unique(arr) {
      return arr.filter((v, i) => arr.indexOf(v) === i);
    }

    function normalizeMaterial(product) {
      return materialFromProduct(product);
    }

    function normalizeSubcategory(product) {
      return product?.subcategory ? String(product.subcategory).trim() : "All";
    }

    const filteredCatalog = catalog.filter(product => {
      const mat = normalizeMaterial(product);
      return mat && mat !== "Other";
    });

    const availableMaterials = materialOrder.filter(mat =>
      filteredCatalog.some(product => normalizeMaterial(product) === mat)
    );

    function getVisibleMaterials() {
      return availableMaterials.filter(mat => !hiddenMaterials.has(mat));
    }

    function productsFor(material, subcategory) {
      let rows = filteredCatalog
        .filter(product => normalizeMaterial(product) === material)
        .filter(product => !boughtHandles.has(product.handle))
        .filter(product => {
          if (!subcategory || subcategory === "All") return true;
          return normalizeSubcategory(product) === subcategory;
        })
        .map(product => ({
          ...product,
          material: normalizeMaterial(product),
          finish: finishFromProduct(product)
        }));

      rows.sort((a, b) => {
        if (state.notTriedSort === "price-asc") return Number(a.price || 0) - Number(b.price || 0);
        if (state.notTriedSort === "price-desc") return Number(b.price || 0) - Number(a.price || 0);
        if (state.notTriedSort === "stock") {
          const sa = getInventoryStatus(a).priority;
          const sb = getInventoryStatus(b).priority;
          if (sa !== sb) return sa - sb;
        }
        return String(a.title || "").localeCompare(String(b.title || ""));
      });

      return rows;
    }

    function availableSubcategoriesFor(material) {
      const raw = unique(
        filteredCatalog
          .filter(product => normalizeMaterial(product) === material)
          .map(product => normalizeSubcategory(product))
          .filter(Boolean)
      );

      const preferred = subcatOrder[material];
      if (preferred) return preferred.filter(x => x === "All" || raw.includes(x));

      const sorted = raw.filter(x => x !== "All").sort((a, b) => a.localeCompare(b));
      return ["All", ...sorted];
    }

    function renderVisibilityManager() {
      visibilityEl.innerHTML = availableMaterials.map(mat => {
        const isHidden = hiddenMaterials.has(mat);
        return `
          <button
            type="button"
            class="fh-chip fh-chip--visibility"
            data-mat="${encodeURIComponent(mat)}"
            aria-pressed="${isHidden ? "false" : "true"}"
            data-hidden="${isHidden ? "true" : "false"}"
          >
            ${escapeHtml(mat)}${isHidden ? " • hidden" : ""}
          </button>
        `;
      }).join("");
    }

    function renderMaterialChips() {
      const visible = getVisibleMaterials();

      if (!visible.length) {
        chipsEl.innerHTML = "";
        subcatsEl.innerHTML = "";
        notTriedListEl.innerHTML = `
          <div class="fh-empty">
            <div class="fh-empty__title">All material categories are hidden</div>
            <div class="fh-empty__text">Use “Manage categories” to turn material groups back on.</div>
          </div>
        `;
        return null;
      }

      const nextMaterial = visible.includes(state.activeNotTriedMaterial)
        ? state.activeNotTriedMaterial
        : (visible.includes("PLA") ? "PLA" : visible[0]);

      chipsEl.innerHTML = visible.map(mat => `
        <button
          class="fh-chip"
          type="button"
          data-mat="${encodeURIComponent(mat)}"
          aria-pressed="${mat === nextMaterial ? "true" : "false"}"
        >
          ${escapeHtml(mat)}
        </button>
      `).join("");

      state.activeNotTriedMaterial = nextMaterial;
      return nextMaterial;
    }

    function renderSubcategoryChips() {
      const subcats = availableSubcategoriesFor(state.activeNotTriedMaterial);

      if (!subcats.length || (subcats.length === 1 && subcats[0] === "All")) {
        subcatsEl.innerHTML = "";
        state.activeNotTriedSubcategory = "All";
        return;
      }

      const nextSubcat = subcats.includes(state.activeNotTriedSubcategory)
        ? state.activeNotTriedSubcategory
        : "All";

      subcatsEl.innerHTML = subcats.map(subcat => `
        <button
          class="fh-chip fh-chip--subcat"
          type="button"
          data-subcat="${encodeURIComponent(subcat)}"
          aria-pressed="${subcat === nextSubcat ? "true" : "false"}"
        >
          ${escapeHtml(subcat)}
        </button>
      `).join("");

      state.activeNotTriedSubcategory = nextSubcat;
    }

    function renderList() {
      const rows = productsFor(state.activeNotTriedMaterial, state.activeNotTriedSubcategory);
      setText("fh-new-count", String(catalog.filter(product => !purchasedMap.has(product.handle)).length));

      if (!rows.length) {
        const suffix = state.activeNotTriedSubcategory && state.activeNotTriedSubcategory !== "All"
          ? ` in ${state.activeNotTriedSubcategory}`
          : "";
        notTriedListEl.innerHTML = `
          <div class="fh-empty">
            <div class="fh-empty__title">Nothing new to try for ${escapeHtml(state.activeNotTriedMaterial)}${escapeHtml(suffix)} 🎉</div>
            <div class="fh-empty__text">Looks like you’ve already bought everything in this category.</div>
          </div>
        `;
        return;
      }

      notTriedListEl.innerHTML = rows.map(product => makeRow(product, { context: "not-tried" })).join("");
    }

    function rerender() {
      renderMaterialChips();
      renderVisibilityManager();
      if (!state.activeNotTriedMaterial) return;
      renderSubcategoryChips();
      renderList();
    }

    rerender();

    chipsEl.onclick = e => {
      const btn = e.target.closest("[data-mat]");
      if (!btn) return;
      state.activeNotTriedMaterial = decodeURIComponent(btn.dataset.mat || "");
      state.activeNotTriedSubcategory = "All";
      rerender();
    };

    subcatsEl.onclick = e => {
      const btn = e.target.closest("[data-subcat]");
      if (!btn) return;
      state.activeNotTriedSubcategory = decodeURIComponent(btn.dataset.subcat || "All");
      rerender();
    };

    visibilityEl.onclick = e => {
      const btn = e.target.closest(".fh-chip--visibility");
      if (!btn) return;

      const mat = decodeURIComponent(btn.dataset.mat || "");
      if (hiddenMaterials.has(mat)) hiddenMaterials.delete(mat);
      else hiddenMaterials.add(mat);

      meta.hiddenMaterials = Array.from(hiddenMaterials);
      persistMeta();

      if (hiddenMaterials.has(state.activeNotTriedMaterial)) {
        state.activeNotTriedMaterial = null;
        state.activeNotTriedSubcategory = "All";
      }

      rerender();
    };

    managerToggleEl?.addEventListener("click", () => {
      const isHidden = managerEl.hasAttribute("hidden");
      if (isHidden) {
        managerEl.removeAttribute("hidden");
        managerToggleEl.setAttribute("aria-expanded", "true");
      } else {
        managerEl.setAttribute("hidden", "");
        managerToggleEl.setAttribute("aria-expanded", "false");
      }
    });
  }

  function renderCartBuilder() {
    const builderEl = document.getElementById("fh-cart-builder");
    const replaceBtn = document.getElementById("fh-replace-cart-checkout");
    const addBtn = document.getElementById("fh-add-tray-to-cart");
    const clearBtn = document.getElementById("fh-clear-cart-builder");

    if (!builderEl) return;

    if (!cartBuilder.length) {
      builderEl.innerHTML = `
        <div class="fh-empty">
          <div class="fh-empty__title">Quick reorder tray is empty</div>
          <div class="fh-empty__text">Add items from Previously ordered, Favourites, or Not yet tried to build your next order.</div>
        </div>
      `;
      if (replaceBtn) replaceBtn.disabled = true;
      if (addBtn) addBtn.disabled = true;
      if (clearBtn) clearBtn.disabled = true;
      return;
    }

    const subtotal = cartBuilderSubtotal();

    builderEl.innerHTML = `
      <div class="fh-cart-builder__summary">
        <div class="fh-cart-builder__count">${cartBuilderCount()} item${cartBuilderCount() === 1 ? "" : "s"} selected</div>
        <div class="fh-cart-builder__subtotal">Tray subtotal: <strong>${centsToMoney(subtotal)}</strong></div>
      </div>

      <div class="fh-list">
        ${cartBuilder.map(item => `
          <div class="fh-row">
            <div class="fh-row__left">
              <div class="fh-row__top">
                ${renderThumb(item)}

                <div class="fh-row__content">
                  <div class="fh-row__title">
                    ${renderColourBubble(item)}
                    <span>${escapeHtml(item.title || "")}</span>
                  </div>

                  <div class="fh-row__badges">
                    ${item.material ? renderBadge(item.material, "material") : ""}
                    ${item.finish ? renderBadge(item.finish, "finish") : ""}
                  </div>

                  <div class="fh-row__meta">
                    ${centsToMoney(item.price)} each • Line total: ${centsToMoney(Number(item.price || 0) * Number(item.qty || 0))}
                  </div>
                </div>
              </div>
            </div>

            <div class="fh-row__actions">
              <div class="fh-qty">
                <button type="button" class="fh-qty__btn" data-qty-minus="${escapeHtml(String(item.variant_id))}">−</button>
                <input class="fh-qty__input" type="number" min="1" value="${escapeHtml(String(item.qty || 1))}" data-qty-input="${escapeHtml(String(item.variant_id))}">
                <button type="button" class="fh-qty__btn" data-qty-plus="${escapeHtml(String(item.variant_id))}">+</button>
              </div>
              <button type="button" class="fh-btn fh-btn--ghost" data-remove-tray="${escapeHtml(String(item.variant_id))}">Remove</button>
            </div>
          </div>
        `).join("")}
      </div>
    `;

    if (replaceBtn) {
      replaceBtn.disabled = cartActionInProgress ? true : false;
      replaceBtn.textContent = cartActionInProgress
        ? "Replacing..."
        : `Replace cart + checkout (${cartBuilderCount()})`;
    }

    if (addBtn) {
      addBtn.disabled = cartActionInProgress ? true : false;
      addBtn.textContent = cartActionInProgress
        ? "Adding..."
        : `Add tray to cart (${cartBuilderCount()})`;
    }

    if (clearBtn) clearBtn.disabled = cartActionInProgress ? true : false;
  }

  function attachGlobalEvents() {
    root.addEventListener("click", e => {
      const favBtn = e.target.closest("[data-fav-toggle]");
      if (favBtn) {
        toggleFavourite(String(favBtn.dataset.favToggle || ""));
        return;
      }

      const addBtn = e.target.closest("[data-add-tray]");
      if (addBtn) {
        const variantId = String(addBtn.dataset.addTray || "");
        const handle = String(addBtn.dataset.handle || "");

        const item =
          Array.from(purchasedMap.values()).find(x => String(x.variant_id) === variantId) ||
          catalogByVariantId.get(variantId) ||
          catalogByHandle.get(handle);

        if (item) {
          addToCartBuilder(item);
        }
        return;
      }

      const removeBtn = e.target.closest("[data-remove-tray]");
      if (removeBtn) {
        removeFromCartBuilder(removeBtn.dataset.removeTray);
        return;
      }

      const minusBtn = e.target.closest("[data-qty-minus]");
      if (minusBtn) {
        const id = minusBtn.dataset.qtyMinus;
        const item = cartBuilder.find(x => String(x.variant_id) === String(id));
        if (!item) return;
        updateCartBuilderQty(id, Math.max(1, Number(item.qty || 1) - 1));
        return;
      }

      const plusBtn = e.target.closest("[data-qty-plus]");
      if (plusBtn) {
        const id = plusBtn.dataset.qtyPlus;
        const item = cartBuilder.find(x => String(x.variant_id) === String(id));
        if (!item) return;
        updateCartBuilderQty(id, Number(item.qty || 1) + 1);
        return;
      }

      const filterBtn = e.target.closest("[data-ordered-material-filter]");
      if (filterBtn) {
        state.orderedMaterialFilter = decodeURIComponent(filterBtn.dataset.orderedMaterialFilter || "All");
        persistMeta();
        buildOrderedMaterialFilters();
        renderOrdered();
        return;
      }

    });

    root.addEventListener("change", e => {
      const qtyInput = e.target.closest("[data-qty-input]");
      if (qtyInput) {
        updateCartBuilderQty(qtyInput.dataset.qtyInput, qtyInput.value);
      }
    });

    searchEl?.addEventListener("input", renderOrdered);

    orderedSortEl?.addEventListener("change", () => {
      state.orderedSort = orderedSortEl.value || "recent";
      persistMeta();
      renderOrdered();
    });

    notTriedSortEl?.addEventListener("change", () => {
      state.notTriedSort = notTriedSortEl.value || "az";
      persistMeta();
      renderNotYetTriedProducts();
    });

    document.getElementById("fh-add-tray-to-cart")?.addEventListener("click", () => {
      addTrayToExistingCart({ redirectTo: "/cart" });
    });

    document.getElementById("fh-replace-cart-checkout")?.addEventListener("click", () => {
      replaceShopifyCartWithTray({ redirectTo: "/checkout" });
    });

    document.getElementById("fh-clear-cart-builder")?.addEventListener("click", () => {
      if (cartActionInProgress) return;
      cartBuilder = [];
      saveCartBuilder(cartBuilder);
      renderCartBuilder();
    });
  }

  orderedSortEl && (orderedSortEl.value = state.orderedSort);
  notTriedSortEl && (notTriedSortEl.value = state.notTriedSort);

  renderHero();
  buildOrderedMaterialFilters();
  renderOrdered();
  renderFavourites();
  renderNotYetTriedProducts();
  renderCartBuilder();
  attachGlobalEvents();
  persistMeta();
})();